import React from 'react';
import './output.css';
import Header from './feacture/header/Header'
import Hero from "./feacture/hero/Hero";
import About from './feacture/About/About';
import Footer from './feacture/Footer/Footer';
import ContactForm from './feacture/Contact/Contact';
import "@fortawesome/fontawesome-free/css/all.css";
import FAQ from './feacture/FAQ/FAQ';
import ExtraComp from './feacture/ExtraComp/ExtraComp';
import AllFeatures from './feacture/AllFeatures/AllFeatures';
import RightSoft from './feacture/RightSoft/RightSoft';
import Reports from './feacture/Reports/Reports';
import Video from './feacture/TutorialVideo/Video';
import SecExtra from './feacture/ExtraComp/SecExtra';
import MainSecond from './feacture/secModule/MainSecond';
import Facilitys from './feacture/Facilitys/Facilitys';
import Activites1 from './feacture/Activites/Activites1';
import  ListItems  from './feacture/ListItems/ListItems';
import OtherProduct from './feacture/OtherProducts/OtherProduct';


function App() {
  
  return (
    <>
      <Header />
      <Hero />
      <RightSoft />
      <Facilitys />
      <AllFeatures />
      <Activites1 />
      <ExtraComp />
      <ListItems />
      <MainSecond />
      <Reports />
      <About />
      <Video />
      <OtherProduct />
      <ContactForm />
      <FAQ />
      <SecExtra />
      <Footer />
    </>
  );
}

export default App;
